// extracted by mini-css-extract-plugin
export var container = "HeaderSp-module--container--3edfc";
export var inner = "HeaderSp-module--inner--1b8fc";
export var lange = "HeaderSp-module--lange--f67ca";
export var logo = "HeaderSp-module--logo--cc30a";